import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProfileCompletion = ({ open, onComplete }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    counselor_name: ''
  });
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.first_name || !formData.last_name || !formData.phone || !formData.counselor_name) {
      toast.error('Tüm alanları doldurunuz');
      return;
    }
    
    // Phone validation
    const phoneRegex = /^[0-9]{10,11}$/;
    if (!phoneRegex.test(formData.phone.replace(/\s/g, ''))) {
      toast.error('Geçerli bir telefon numarası giriniz (10-11 rakam)');
      return;
    }
    
    setLoading(true);
    
    try {
      await axios.post(
        `${API}/auth/complete-profile`,
        formData,
        { withCredentials: true }
      );
      toast.success('Profil tamamlandı!');
      onComplete();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Profil tamamlanamadı');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={() => {}} onEscapeKeyDown={(e) => e.preventDefault()}>
      <DialogContent className="max-w-md" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-2xl">Profil Bilgilerinizi Tamamlayın</DialogTitle>
          <CardDescription>
            Sınava başlayabilmek için aşağıdaki bilgileri doldurunuz
          </CardDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="first_name">Ad *</Label>
            <Input
              id="first_name"
              data-testid="profile-first-name-input"
              type="text"
              placeholder="Adınız"
              value={formData.first_name}
              onChange={(e) => setFormData({...formData, first_name: e.target.value})}
              required
            />
          </div>
          
          <div>
            <Label htmlFor="last_name">Soyad *</Label>
            <Input
              id="last_name"
              data-testid="profile-last-name-input"
              type="text"
              placeholder="Soyadınız"
              value={formData.last_name}
              onChange={(e) => setFormData({...formData, last_name: e.target.value})}
              required
            />
          </div>
          
          <div>
            <Label htmlFor="phone">Telefon Numarası *</Label>
            <Input
              id="phone"
              data-testid="profile-phone-input"
              type="tel"
              placeholder="05XX XXX XX XX"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              required
            />
          </div>
          
          <div>
            <Label htmlFor="counselor_name">Eğitim Danışmanı *</Label>
            <Input
              id="counselor_name"
              data-testid="profile-counselor-input"
              type="text"
              placeholder="Danışman adı"
              value={formData.counselor_name}
              onChange={(e) => setFormData({...formData, counselor_name: e.target.value})}
              required
            />
          </div>
          
          <Button
            type="submit"
            data-testid="profile-submit-button"
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
            disabled={loading}
          >
            {loading ? 'Kaydediliyor...' : 'Profili Tamamla'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileCompletion;
